// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// InitialState
import initialState from './initialState'

// Controller
import ordersCtrl from 'hfty-ctrl-orders'


export default createReducer({
  ...initialState,
}, {
  ...ordersCtrl.reducers,
})
